/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddRiskThreatsToRisk } from '../model';
// @ts-ignore
import type { AddRiskToProject } from '../model';
// @ts-ignore
import type { EditRisk } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { OrganizationProjectQuantificationTimeseriesResult } from '../model';
// @ts-ignore
import type { ProjectRiskQuantificationTimeseriesResult } from '../model';
// @ts-ignore
import type { QuantificationRequest } from '../model';
// @ts-ignore
import type { QuantificationResult } from '../model';
// @ts-ignore
import type { Risk } from '../model';
// @ts-ignore
import type { RiskExpandedPaginated } from '../model';
// @ts-ignore
import type { RiskLimitSimulation } from '../model';
// @ts-ignore
import type { RiskPaginated } from '../model';
// @ts-ignore
import type { RiskQuantificationMethodFilter } from '../model';
// @ts-ignore
import type { RiskQuantificationSorting } from '../model';
// @ts-ignore
import type { RiskQuantificationStatusFilter } from '../model';
// @ts-ignore
import type { RiskQuantificationTimeseriesResult } from '../model';
// @ts-ignore
import type { RiskSorting } from '../model';
// @ts-ignore
import type { RiskStatus } from '../model';
// @ts-ignore
import type { RiskStatusByCategory } from '../model';
// @ts-ignore
import type { RiskThreat } from '../model';
// @ts-ignore
import type { RiskThreatExpandedPaginated } from '../model';
// @ts-ignore
import type { RiskThreatQuantification } from '../model';
// @ts-ignore
import type { RiskThreatQuantificationDeltaSchema } from '../model';
// @ts-ignore
import type { RiskThreatQuantificationPaginated } from '../model';
// @ts-ignore
import type { RiskThreatQuantificationTimeseriesResult } from '../model';
// @ts-ignore
import type { RisksOverview } from '../model';
/**
 * ProjectRisksApi - axios parameter creator
 */
export const ProjectRisksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Risk Threats To Risk
         * @param {string} riskId 
         * @param {AddRiskThreatsToRisk} addRiskThreatsToRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRiskThreatsToRisk: async (riskId: string, addRiskThreatsToRisk: AddRiskThreatsToRisk, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('addRiskThreatsToRisk', 'riskId', riskId)
            // verify required parameter 'addRiskThreatsToRisk' is not null or undefined
            assertParamExists('addRiskThreatsToRisk', 'addRiskThreatsToRisk', addRiskThreatsToRisk)
            const localVarPath = `/risks/{risk_id}/threats`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRiskThreatsToRisk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an existing risk to a project.
         * @summary Add Risks To Project
         * @param {AddRiskToProject} addRiskToProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRisksToProject: async (addRiskToProject: AddRiskToProject, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addRiskToProject' is not null or undefined
            assertParamExists('addRisksToProject', 'addRiskToProject', addRiskToProject)
            const localVarPath = `/risks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRiskToProject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a risk.
         * @summary Delete Risk
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRisk: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('deleteRisk', 'riskId', riskId)
            const localVarPath = `/risks/{risk_id}`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a risk threat.
         * @summary Delete Risk Threat
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRiskThreat: async (riskId: string, riskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('deleteRiskThreat', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('deleteRiskThreat', 'riskThreatId', riskThreatId)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest Risk Threat Quantification
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestRiskThreatQuantification: async (riskId: string, riskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getLatestRiskThreatQuantification', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('getLatestRiskThreatQuantification', 'riskThreatId', riskThreatId)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}/quantification/latest`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get daily aggregated quantification timeseries for all projects in an organization.
         * @summary Get Organization Projects Quantifications Timeseries
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationProjectsQuantificationsTimeseries: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getOrganizationProjectsQuantificationsTimeseries', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getOrganizationProjectsQuantificationsTimeseries', 'endDate', endDate)
            const localVarPath = `/risks/organizations/timeseries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get daily aggregated quantification timeseries for all risks in a project.
         * @summary Get Project Risks Quantifications Timeseries
         * @param {string} projectId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRisksQuantificationsTimeseries: async (projectId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectRisksQuantificationsTimeseries', 'projectId', projectId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getProjectRisksQuantificationsTimeseries', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getProjectRisksQuantificationsTimeseries', 'endDate', endDate)
            const localVarPath = `/risks/projects/timeseries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single risk by ID.
         * @summary Get Risk
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisk: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRisk', 'riskId', riskId)
            const localVarPath = `/risks/{risk_id}`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the quantification timeseries for all risk threats belonging to a risk.
         * @summary Get Risk Quantifications Timeseries
         * @param {string} riskId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskQuantificationsTimeseries: async (riskId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskQuantificationsTimeseries', 'riskId', riskId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRiskQuantificationsTimeseries', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRiskQuantificationsTimeseries', 'endDate', endDate)
            const localVarPath = `/risks/{risk_id}/timeseries`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return risk status by category (optionally filtered by project).
         * @summary Get Risk Status By Category
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskStatusByCategory: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getRiskStatusByCategory', 'projectId', projectId)
            const localVarPath = `/risks/metrics/risk-status-by-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve details of a specific risk threat within a risk.
         * @summary Get Risk Threat
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreat: async (riskId: string, riskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreat', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('getRiskThreat', 'riskThreatId', riskThreatId)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Risk Threat Quantification
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {string} riskQuantificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantification: async (riskId: string, riskThreatId: string, riskQuantificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreatQuantification', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('getRiskThreatQuantification', 'riskThreatId', riskThreatId)
            // verify required parameter 'riskQuantificationId' is not null or undefined
            assertParamExists('getRiskThreatQuantification', 'riskQuantificationId', riskQuantificationId)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}/quantification/{risk_quantification_id}`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)))
                .replace('{risk_quantification_id}', encodeURIComponent(String(riskQuantificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Risk Threat Quantification Delta
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantificationDelta: async (riskId: string, riskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreatQuantificationDelta', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('getRiskThreatQuantificationDelta', 'riskThreatId', riskThreatId)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}/quantification/delta`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Risk Threat Quantifications
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RiskQuantificationSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {RiskQuantificationMethodFilter | null} [method] 
         * @param {RiskQuantificationStatusFilter | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantifications: async (riskId: string, riskThreatId: string, page?: number, size?: number, sortBy?: RiskQuantificationSorting | null, descending?: boolean | null, method?: RiskQuantificationMethodFilter | null, status?: RiskQuantificationStatusFilter | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreatQuantifications', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('getRiskThreatQuantifications', 'riskThreatId', riskThreatId)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}/quantification`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Risk Threat Quantifications Timeseries
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantificationsTimeseries: async (riskId: string, riskThreatId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreatQuantificationsTimeseries', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('getRiskThreatQuantificationsTimeseries', 'riskThreatId', riskThreatId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getRiskThreatQuantificationsTimeseries', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getRiskThreatQuantificationsTimeseries', 'endDate', endDate)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}/quantification/timeseries`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Risk Threats
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreats: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreats', 'riskId', riskId)
            const localVarPath = `/risks/{risk_id}/threats`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Risk Threats Expanded
         * @param {string} riskId 
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatsExpanded: async (riskId: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('getRiskThreatsExpanded', 'riskId', riskId)
            const localVarPath = `/risks/{risk_id}/threats/expanded`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all risks for a project.
         * @summary Get Risks
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {RiskStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisks: async (projectId: string, page?: number, size?: number, sortBy?: RiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, status?: RiskStatus | null, name?: string | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getRisks', 'projectId', projectId)
            const localVarPath = `/risks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (organizationRiskCategoryId !== undefined) {
                localVarQueryParameter['organization_risk_category_id'] = organizationRiskCategoryId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all risks for a project.
         * @summary Get Risks Expanded
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {RiskStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisksExpanded: async (projectId: string, page?: number, size?: number, sortBy?: RiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, status?: RiskStatus | null, name?: string | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getRisksExpanded', 'projectId', projectId)
            const localVarPath = `/risks/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (organizationRiskCategoryId !== undefined) {
                localVarQueryParameter['organization_risk_category_id'] = organizationRiskCategoryId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return project risks overview.
         * @summary Get Risks Overview
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisksOverview: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getRisksOverview', 'projectId', projectId)
            const localVarPath = `/risks/metrics/risks-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simulate the risk limit for a new risk in a category.
         * @summary Get Simulated Risk Limit
         * @param {RiskLimitSimulation} riskLimitSimulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatedRiskLimit: async (riskLimitSimulation: RiskLimitSimulation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskLimitSimulation' is not null or undefined
            assertParamExists('getSimulatedRiskLimit', 'riskLimitSimulation', riskLimitSimulation)
            const localVarPath = `/risks/simulate-risk-limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskLimitSimulation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Quantify Risk Threat
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {QuantificationRequest} quantificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quantifyRiskThreat: async (riskId: string, riskThreatId: string, quantificationRequest: QuantificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('quantifyRiskThreat', 'riskId', riskId)
            // verify required parameter 'riskThreatId' is not null or undefined
            assertParamExists('quantifyRiskThreat', 'riskThreatId', riskThreatId)
            // verify required parameter 'quantificationRequest' is not null or undefined
            assertParamExists('quantifyRiskThreat', 'quantificationRequest', quantificationRequest)
            const localVarPath = `/risks/{risk_id}/threats/{risk_threat_id}/quantify`
                .replace('{risk_id}', encodeURIComponent(String(riskId)))
                .replace('{risk_threat_id}', encodeURIComponent(String(riskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quantificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit a single risk by ID.
         * @summary Update Risk
         * @param {string} riskId 
         * @param {EditRisk} editRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRisk: async (riskId: string, editRisk: EditRisk, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('updateRisk', 'riskId', riskId)
            // verify required parameter 'editRisk' is not null or undefined
            assertParamExists('updateRisk', 'editRisk', editRisk)
            const localVarPath = `/risks/{risk_id}`
                .replace('{risk_id}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRisk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectRisksApi - functional programming interface
 */
export const ProjectRisksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectRisksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Risk Threats To Risk
         * @param {string} riskId 
         * @param {AddRiskThreatsToRisk} addRiskThreatsToRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRiskThreatsToRisk(riskId: string, addRiskThreatsToRisk: AddRiskThreatsToRisk, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskThreat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRiskThreatsToRisk(riskId, addRiskThreatsToRisk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.addRiskThreatsToRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add an existing risk to a project.
         * @summary Add Risks To Project
         * @param {AddRiskToProject} addRiskToProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRisksToProject(addRiskToProject: AddRiskToProject, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Risk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRisksToProject(addRiskToProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.addRisksToProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a risk.
         * @summary Delete Risk
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRisk(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRisk(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.deleteRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a risk threat.
         * @summary Delete Risk Threat
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRiskThreat(riskId: string, riskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRiskThreat(riskId, riskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.deleteRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest Risk Threat Quantification
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestRiskThreatQuantification(riskId: string, riskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreatQuantification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestRiskThreatQuantification(riskId, riskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getLatestRiskThreatQuantification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get daily aggregated quantification timeseries for all projects in an organization.
         * @summary Get Organization Projects Quantifications Timeseries
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationProjectsQuantificationsTimeseries(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProjectQuantificationTimeseriesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationProjectsQuantificationsTimeseries(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getOrganizationProjectsQuantificationsTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get daily aggregated quantification timeseries for all risks in a project.
         * @summary Get Project Risks Quantifications Timeseries
         * @param {string} projectId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectRisksQuantificationsTimeseries(projectId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRiskQuantificationTimeseriesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectRisksQuantificationsTimeseries(projectId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getProjectRisksQuantificationsTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single risk by ID.
         * @summary Get Risk
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRisk(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Risk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRisk(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the quantification timeseries for all risk threats belonging to a risk.
         * @summary Get Risk Quantifications Timeseries
         * @param {string} riskId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskQuantificationsTimeseries(riskId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskQuantificationTimeseriesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskQuantificationsTimeseries(riskId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskQuantificationsTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return risk status by category (optionally filtered by project).
         * @summary Get Risk Status By Category
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskStatusByCategory(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskStatusByCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskStatusByCategory(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskStatusByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve details of a specific risk threat within a risk.
         * @summary Get Risk Threat
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreat(riskId: string, riskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreat(riskId, riskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Risk Threat Quantification
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {string} riskQuantificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreatQuantification(riskId: string, riskThreatId: string, riskQuantificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreatQuantification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreatQuantification(riskId, riskThreatId, riskQuantificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreatQuantification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Risk Threat Quantification Delta
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreatQuantificationDelta(riskId: string, riskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreatQuantificationDeltaSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreatQuantificationDelta(riskId, riskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreatQuantificationDelta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Risk Threat Quantifications
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RiskQuantificationSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {RiskQuantificationMethodFilter | null} [method] 
         * @param {RiskQuantificationStatusFilter | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreatQuantifications(riskId: string, riskThreatId: string, page?: number, size?: number, sortBy?: RiskQuantificationSorting | null, descending?: boolean | null, method?: RiskQuantificationMethodFilter | null, status?: RiskQuantificationStatusFilter | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreatQuantificationPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreatQuantifications(riskId, riskThreatId, page, size, sortBy, descending, method, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreatQuantifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Risk Threat Quantifications Timeseries
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreatQuantificationsTimeseries(riskId: string, riskThreatId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreatQuantificationTimeseriesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreatQuantificationsTimeseries(riskId, riskThreatId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreatQuantificationsTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Risk Threats
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreats(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskThreat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreats(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Risk Threats Expanded
         * @param {string} riskId 
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreatsExpanded(riskId: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskThreatExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreatsExpanded(riskId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRiskThreatsExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all risks for a project.
         * @summary Get Risks
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {RiskStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRisks(projectId: string, page?: number, size?: number, sortBy?: RiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, status?: RiskStatus | null, name?: string | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRisks(projectId, page, size, sortBy, descending, organizationRiskCategoryId, status, name, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRisks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all risks for a project.
         * @summary Get Risks Expanded
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {RiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {RiskStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRisksExpanded(projectId: string, page?: number, size?: number, sortBy?: RiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, status?: RiskStatus | null, name?: string | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRisksExpanded(projectId, page, size, sortBy, descending, organizationRiskCategoryId, status, name, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRisksExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return project risks overview.
         * @summary Get Risks Overview
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRisksOverview(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RisksOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRisksOverview(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getRisksOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simulate the risk limit for a new risk in a category.
         * @summary Get Simulated Risk Limit
         * @param {RiskLimitSimulation} riskLimitSimulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulatedRiskLimit(riskLimitSimulation: RiskLimitSimulation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulatedRiskLimit(riskLimitSimulation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.getSimulatedRiskLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Quantify Risk Threat
         * @param {string} riskId 
         * @param {string} riskThreatId 
         * @param {QuantificationRequest} quantificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quantifyRiskThreat(riskId: string, riskThreatId: string, quantificationRequest: QuantificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuantificationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quantifyRiskThreat(riskId, riskThreatId, quantificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.quantifyRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit a single risk by ID.
         * @summary Update Risk
         * @param {string} riskId 
         * @param {EditRisk} editRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRisk(riskId: string, editRisk: EditRisk, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Risk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRisk(riskId, editRisk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectRisksApi.updateRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectRisksApi - factory interface
 */
export const ProjectRisksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectRisksApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Risk Threats To Risk
         * @param {ProjectRisksApiAddRiskThreatsToRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRiskThreatsToRisk(requestParameters: ProjectRisksApiAddRiskThreatsToRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskThreat>> {
            return localVarFp.addRiskThreatsToRisk(requestParameters.riskId, requestParameters.addRiskThreatsToRisk, options).then((request) => request(axios, basePath));
        },
        /**
         * Add an existing risk to a project.
         * @summary Add Risks To Project
         * @param {ProjectRisksApiAddRisksToProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRisksToProject(requestParameters: ProjectRisksApiAddRisksToProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<Risk> {
            return localVarFp.addRisksToProject(requestParameters.addRiskToProject, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a risk.
         * @summary Delete Risk
         * @param {ProjectRisksApiDeleteRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRisk(requestParameters: ProjectRisksApiDeleteRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRisk(requestParameters.riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a risk threat.
         * @summary Delete Risk Threat
         * @param {ProjectRisksApiDeleteRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRiskThreat(requestParameters: ProjectRisksApiDeleteRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRiskThreat(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest Risk Threat Quantification
         * @param {ProjectRisksApiGetLatestRiskThreatQuantificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestRiskThreatQuantification(requestParameters: ProjectRisksApiGetLatestRiskThreatQuantificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreatQuantification> {
            return localVarFp.getLatestRiskThreatQuantification(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get daily aggregated quantification timeseries for all projects in an organization.
         * @summary Get Organization Projects Quantifications Timeseries
         * @param {ProjectRisksApiGetOrganizationProjectsQuantificationsTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationProjectsQuantificationsTimeseries(requestParameters: ProjectRisksApiGetOrganizationProjectsQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationProjectQuantificationTimeseriesResult> {
            return localVarFp.getOrganizationProjectsQuantificationsTimeseries(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get daily aggregated quantification timeseries for all risks in a project.
         * @summary Get Project Risks Quantifications Timeseries
         * @param {ProjectRisksApiGetProjectRisksQuantificationsTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRisksQuantificationsTimeseries(requestParameters: ProjectRisksApiGetProjectRisksQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectRiskQuantificationTimeseriesResult> {
            return localVarFp.getProjectRisksQuantificationsTimeseries(requestParameters.projectId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single risk by ID.
         * @summary Get Risk
         * @param {ProjectRisksApiGetRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisk(requestParameters: ProjectRisksApiGetRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<Risk> {
            return localVarFp.getRisk(requestParameters.riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the quantification timeseries for all risk threats belonging to a risk.
         * @summary Get Risk Quantifications Timeseries
         * @param {ProjectRisksApiGetRiskQuantificationsTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskQuantificationsTimeseries(requestParameters: ProjectRisksApiGetRiskQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskQuantificationTimeseriesResult> {
            return localVarFp.getRiskQuantificationsTimeseries(requestParameters.riskId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Return risk status by category (optionally filtered by project).
         * @summary Get Risk Status By Category
         * @param {ProjectRisksApiGetRiskStatusByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskStatusByCategory(requestParameters: ProjectRisksApiGetRiskStatusByCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskStatusByCategory>> {
            return localVarFp.getRiskStatusByCategory(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve details of a specific risk threat within a risk.
         * @summary Get Risk Threat
         * @param {ProjectRisksApiGetRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreat(requestParameters: ProjectRisksApiGetRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreat> {
            return localVarFp.getRiskThreat(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Risk Threat Quantification
         * @param {ProjectRisksApiGetRiskThreatQuantificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantification(requestParameters: ProjectRisksApiGetRiskThreatQuantificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreatQuantification> {
            return localVarFp.getRiskThreatQuantification(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.riskQuantificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Risk Threat Quantification Delta
         * @param {ProjectRisksApiGetRiskThreatQuantificationDeltaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantificationDelta(requestParameters: ProjectRisksApiGetRiskThreatQuantificationDeltaRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreatQuantificationDeltaSchema> {
            return localVarFp.getRiskThreatQuantificationDelta(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Risk Threat Quantifications
         * @param {ProjectRisksApiGetRiskThreatQuantificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantifications(requestParameters: ProjectRisksApiGetRiskThreatQuantificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreatQuantificationPaginated> {
            return localVarFp.getRiskThreatQuantifications(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.method, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Risk Threat Quantifications Timeseries
         * @param {ProjectRisksApiGetRiskThreatQuantificationsTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatQuantificationsTimeseries(requestParameters: ProjectRisksApiGetRiskThreatQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreatQuantificationTimeseriesResult> {
            return localVarFp.getRiskThreatQuantificationsTimeseries(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Risk Threats
         * @param {ProjectRisksApiGetRiskThreatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreats(requestParameters: ProjectRisksApiGetRiskThreatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskThreat>> {
            return localVarFp.getRiskThreats(requestParameters.riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Risk Threats Expanded
         * @param {ProjectRisksApiGetRiskThreatsExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatsExpanded(requestParameters: ProjectRisksApiGetRiskThreatsExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskThreatExpandedPaginated> {
            return localVarFp.getRiskThreatsExpanded(requestParameters.riskId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all risks for a project.
         * @summary Get Risks
         * @param {ProjectRisksApiGetRisksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisks(requestParameters: ProjectRisksApiGetRisksRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskPaginated> {
            return localVarFp.getRisks(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.status, requestParameters.name, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all risks for a project.
         * @summary Get Risks Expanded
         * @param {ProjectRisksApiGetRisksExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisksExpanded(requestParameters: ProjectRisksApiGetRisksExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskExpandedPaginated> {
            return localVarFp.getRisksExpanded(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.status, requestParameters.name, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Return project risks overview.
         * @summary Get Risks Overview
         * @param {ProjectRisksApiGetRisksOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRisksOverview(requestParameters: ProjectRisksApiGetRisksOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<RisksOverview> {
            return localVarFp.getRisksOverview(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Simulate the risk limit for a new risk in a category.
         * @summary Get Simulated Risk Limit
         * @param {ProjectRisksApiGetSimulatedRiskLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatedRiskLimit(requestParameters: ProjectRisksApiGetSimulatedRiskLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getSimulatedRiskLimit(requestParameters.riskLimitSimulation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Quantify Risk Threat
         * @param {ProjectRisksApiQuantifyRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quantifyRiskThreat(requestParameters: ProjectRisksApiQuantifyRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuantificationResult> {
            return localVarFp.quantifyRiskThreat(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.quantificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit a single risk by ID.
         * @summary Update Risk
         * @param {ProjectRisksApiUpdateRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRisk(requestParameters: ProjectRisksApiUpdateRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<Risk> {
            return localVarFp.updateRisk(requestParameters.riskId, requestParameters.editRisk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addRiskThreatsToRisk operation in ProjectRisksApi.
 */
export interface ProjectRisksApiAddRiskThreatsToRiskRequest {
    readonly riskId: string

    readonly addRiskThreatsToRisk: AddRiskThreatsToRisk
}

/**
 * Request parameters for addRisksToProject operation in ProjectRisksApi.
 */
export interface ProjectRisksApiAddRisksToProjectRequest {
    readonly addRiskToProject: AddRiskToProject
}

/**
 * Request parameters for deleteRisk operation in ProjectRisksApi.
 */
export interface ProjectRisksApiDeleteRiskRequest {
    readonly riskId: string
}

/**
 * Request parameters for deleteRiskThreat operation in ProjectRisksApi.
 */
export interface ProjectRisksApiDeleteRiskThreatRequest {
    readonly riskId: string

    readonly riskThreatId: string
}

/**
 * Request parameters for getLatestRiskThreatQuantification operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetLatestRiskThreatQuantificationRequest {
    readonly riskId: string

    readonly riskThreatId: string
}

/**
 * Request parameters for getOrganizationProjectsQuantificationsTimeseries operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetOrganizationProjectsQuantificationsTimeseriesRequest {
    readonly startDate: string

    readonly endDate: string
}

/**
 * Request parameters for getProjectRisksQuantificationsTimeseries operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetProjectRisksQuantificationsTimeseriesRequest {
    readonly projectId: string

    readonly startDate: string

    readonly endDate: string
}

/**
 * Request parameters for getRisk operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskRequest {
    readonly riskId: string
}

/**
 * Request parameters for getRiskQuantificationsTimeseries operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskQuantificationsTimeseriesRequest {
    readonly riskId: string

    readonly startDate: string

    readonly endDate: string
}

/**
 * Request parameters for getRiskStatusByCategory operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskStatusByCategoryRequest {
    readonly projectId: string
}

/**
 * Request parameters for getRiskThreat operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatRequest {
    readonly riskId: string

    readonly riskThreatId: string
}

/**
 * Request parameters for getRiskThreatQuantification operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatQuantificationRequest {
    readonly riskId: string

    readonly riskThreatId: string

    readonly riskQuantificationId: string
}

/**
 * Request parameters for getRiskThreatQuantificationDelta operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatQuantificationDeltaRequest {
    readonly riskId: string

    readonly riskThreatId: string
}

/**
 * Request parameters for getRiskThreatQuantifications operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatQuantificationsRequest {
    readonly riskId: string

    readonly riskThreatId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: RiskQuantificationSorting | null

    readonly descending?: boolean | null

    readonly method?: RiskQuantificationMethodFilter | null

    readonly status?: RiskQuantificationStatusFilter | null
}

/**
 * Request parameters for getRiskThreatQuantificationsTimeseries operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatQuantificationsTimeseriesRequest {
    readonly riskId: string

    readonly riskThreatId: string

    readonly startDate: string

    readonly endDate: string
}

/**
 * Request parameters for getRiskThreats operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatsRequest {
    readonly riskId: string
}

/**
 * Request parameters for getRiskThreatsExpanded operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRiskThreatsExpandedRequest {
    readonly riskId: string

    /**
     * Page number
     */
    readonly page?: number

    /**
     * Page size
     */
    readonly size?: number
}

/**
 * Request parameters for getRisks operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRisksRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: RiskSorting | null

    readonly descending?: boolean | null

    readonly organizationRiskCategoryId?: string | null

    readonly status?: RiskStatus | null

    readonly name?: string | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getRisksExpanded operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRisksExpandedRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: RiskSorting | null

    readonly descending?: boolean | null

    readonly organizationRiskCategoryId?: string | null

    readonly status?: RiskStatus | null

    readonly name?: string | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getRisksOverview operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetRisksOverviewRequest {
    readonly projectId: string
}

/**
 * Request parameters for getSimulatedRiskLimit operation in ProjectRisksApi.
 */
export interface ProjectRisksApiGetSimulatedRiskLimitRequest {
    readonly riskLimitSimulation: RiskLimitSimulation
}

/**
 * Request parameters for quantifyRiskThreat operation in ProjectRisksApi.
 */
export interface ProjectRisksApiQuantifyRiskThreatRequest {
    readonly riskId: string

    readonly riskThreatId: string

    readonly quantificationRequest: QuantificationRequest
}

/**
 * Request parameters for updateRisk operation in ProjectRisksApi.
 */
export interface ProjectRisksApiUpdateRiskRequest {
    readonly riskId: string

    readonly editRisk: EditRisk
}

/**
 * ProjectRisksApi - object-oriented interface
 */
export class ProjectRisksApi extends BaseAPI {
    /**
     * 
     * @summary Add Risk Threats To Risk
     * @param {ProjectRisksApiAddRiskThreatsToRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addRiskThreatsToRisk(requestParameters: ProjectRisksApiAddRiskThreatsToRiskRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).addRiskThreatsToRisk(requestParameters.riskId, requestParameters.addRiskThreatsToRisk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add an existing risk to a project.
     * @summary Add Risks To Project
     * @param {ProjectRisksApiAddRisksToProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addRisksToProject(requestParameters: ProjectRisksApiAddRisksToProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).addRisksToProject(requestParameters.addRiskToProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a risk.
     * @summary Delete Risk
     * @param {ProjectRisksApiDeleteRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRisk(requestParameters: ProjectRisksApiDeleteRiskRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).deleteRisk(requestParameters.riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a risk threat.
     * @summary Delete Risk Threat
     * @param {ProjectRisksApiDeleteRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRiskThreat(requestParameters: ProjectRisksApiDeleteRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).deleteRiskThreat(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest Risk Threat Quantification
     * @param {ProjectRisksApiGetLatestRiskThreatQuantificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestRiskThreatQuantification(requestParameters: ProjectRisksApiGetLatestRiskThreatQuantificationRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getLatestRiskThreatQuantification(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get daily aggregated quantification timeseries for all projects in an organization.
     * @summary Get Organization Projects Quantifications Timeseries
     * @param {ProjectRisksApiGetOrganizationProjectsQuantificationsTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationProjectsQuantificationsTimeseries(requestParameters: ProjectRisksApiGetOrganizationProjectsQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getOrganizationProjectsQuantificationsTimeseries(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get daily aggregated quantification timeseries for all risks in a project.
     * @summary Get Project Risks Quantifications Timeseries
     * @param {ProjectRisksApiGetProjectRisksQuantificationsTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectRisksQuantificationsTimeseries(requestParameters: ProjectRisksApiGetProjectRisksQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getProjectRisksQuantificationsTimeseries(requestParameters.projectId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single risk by ID.
     * @summary Get Risk
     * @param {ProjectRisksApiGetRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRisk(requestParameters: ProjectRisksApiGetRiskRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRisk(requestParameters.riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the quantification timeseries for all risk threats belonging to a risk.
     * @summary Get Risk Quantifications Timeseries
     * @param {ProjectRisksApiGetRiskQuantificationsTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskQuantificationsTimeseries(requestParameters: ProjectRisksApiGetRiskQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskQuantificationsTimeseries(requestParameters.riskId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return risk status by category (optionally filtered by project).
     * @summary Get Risk Status By Category
     * @param {ProjectRisksApiGetRiskStatusByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskStatusByCategory(requestParameters: ProjectRisksApiGetRiskStatusByCategoryRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskStatusByCategory(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve details of a specific risk threat within a risk.
     * @summary Get Risk Threat
     * @param {ProjectRisksApiGetRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreat(requestParameters: ProjectRisksApiGetRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreat(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Risk Threat Quantification
     * @param {ProjectRisksApiGetRiskThreatQuantificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreatQuantification(requestParameters: ProjectRisksApiGetRiskThreatQuantificationRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreatQuantification(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.riskQuantificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Risk Threat Quantification Delta
     * @param {ProjectRisksApiGetRiskThreatQuantificationDeltaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreatQuantificationDelta(requestParameters: ProjectRisksApiGetRiskThreatQuantificationDeltaRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreatQuantificationDelta(requestParameters.riskId, requestParameters.riskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Risk Threat Quantifications
     * @param {ProjectRisksApiGetRiskThreatQuantificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreatQuantifications(requestParameters: ProjectRisksApiGetRiskThreatQuantificationsRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreatQuantifications(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.method, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Risk Threat Quantifications Timeseries
     * @param {ProjectRisksApiGetRiskThreatQuantificationsTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreatQuantificationsTimeseries(requestParameters: ProjectRisksApiGetRiskThreatQuantificationsTimeseriesRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreatQuantificationsTimeseries(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Risk Threats
     * @param {ProjectRisksApiGetRiskThreatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreats(requestParameters: ProjectRisksApiGetRiskThreatsRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreats(requestParameters.riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Risk Threats Expanded
     * @param {ProjectRisksApiGetRiskThreatsExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreatsExpanded(requestParameters: ProjectRisksApiGetRiskThreatsExpandedRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRiskThreatsExpanded(requestParameters.riskId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all risks for a project.
     * @summary Get Risks
     * @param {ProjectRisksApiGetRisksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRisks(requestParameters: ProjectRisksApiGetRisksRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRisks(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.status, requestParameters.name, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all risks for a project.
     * @summary Get Risks Expanded
     * @param {ProjectRisksApiGetRisksExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRisksExpanded(requestParameters: ProjectRisksApiGetRisksExpandedRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRisksExpanded(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.status, requestParameters.name, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return project risks overview.
     * @summary Get Risks Overview
     * @param {ProjectRisksApiGetRisksOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRisksOverview(requestParameters: ProjectRisksApiGetRisksOverviewRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getRisksOverview(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simulate the risk limit for a new risk in a category.
     * @summary Get Simulated Risk Limit
     * @param {ProjectRisksApiGetSimulatedRiskLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulatedRiskLimit(requestParameters: ProjectRisksApiGetSimulatedRiskLimitRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).getSimulatedRiskLimit(requestParameters.riskLimitSimulation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Quantify Risk Threat
     * @param {ProjectRisksApiQuantifyRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quantifyRiskThreat(requestParameters: ProjectRisksApiQuantifyRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).quantifyRiskThreat(requestParameters.riskId, requestParameters.riskThreatId, requestParameters.quantificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit a single risk by ID.
     * @summary Update Risk
     * @param {ProjectRisksApiUpdateRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRisk(requestParameters: ProjectRisksApiUpdateRiskRequest, options?: RawAxiosRequestConfig) {
        return ProjectRisksApiFp(this.configuration).updateRisk(requestParameters.riskId, requestParameters.editRisk, options).then((request) => request(this.axios, this.basePath));
    }
}

